import Vue from 'vue'
import Vuex from 'vuex'
import { HTTP } from '../utils'
import router from '../router'

Vue.use(Vuex)

export const store = new Vuex.Store({
  /**
   * S T A T E
   */
  state: {
    user: null
  },

  /**
   * M U T A T I O N S
   */
  mutations: {
    setUser (state, payload) {
      state.user = payload
      // console.log('setUser: ' + JSON.stringify(payload))
      HTTP.defaults.headers.common['Authorization'] = payload === null ? '' : payload.uid
      if (payload !== null && payload.uid !== null) {
        localStorage.setItem('token', payload.uid)
        localStorage.setItem('hotel_name', payload.hotel)
      } else {
        localStorage.removeItem('token')
        localStorage.removeItem('hotel_name')
      }
    }
  },

  /**
   * A C T I O N S
   */
  actions: {
    logout ({commit}) {
      commit('setUser', null)
      router.push('/signin')
    }
  },

  /**
   * G E T T E R S
   */
  getters: {
    user: state => state.user
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js